import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import CoachKris from "@/views/CoachKris.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/coach",
    name: "coach",
    component: () => import("../views/CoachKris.vue"),
  },
  {
    path: "/theory",
    name: "theory",
    component: () => import("../views/TheoryView.vue"),
    children: [
      {
        path: "gear",
        name: "theory-gear",
        component: () => import("../views/theory/GearView.vue"),
      },
      {
        path: "workout",
        name: "theory-workout",
        component: () => import("../views/theory/WorkoutView.vue"),
      },
      {
        path: "tips",
        name: "theory-tips",
        component: () => import("../views/theory/TrickDB.vue"),
      },
    ],
  },
  {
    path: "/booking",
    name: "booking",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
